<template>
  <button type="button"
          class="serp__filters--marked-item-button q-btn q-btn-light q-btn-sm q-me-2 q-mb-2 q-position-relative q-rounded-3 q-shadow-sm"
  >
    {{ filtersStore.getFilterLabelByFilterName(filterName) }}:
    <span class="marked-item_min" v-if="activeFilter.min">
        <span class="marked-item__min-text">{{ SmartSearchTranslations.filters.from }}</span>
        <span class="marked-item__min-value q-ps-1">{{
            filterName === 'price' ? formatPrice(activeFilter.min, getCurrencyCode, true) :
                `${activeFilter.min} ${filtersStore.getFilterUnit(filterName) || ''}`
          }}
        </span>
      </span>
    <span class="marked-item_max" v-if="activeFilter.max">
          <span class="marked-item__max-text">&nbsp;{{ SmartSearchTranslations.filters.to }}</span>
                <span
                    class="marked-item__max-value q-ps-1">{{
                    filterName === 'price' ? formatPrice(activeFilter.max, getCurrencyCode, true) :
                        `${activeFilter.max} ${filtersStore.getFilterUnit(filterName) || ''}`
                  }}
                </span>
      </span>
    <a class="q-ms-1 q-stretched-link q-btn-close"
       @click.prevent="filtersStore.removeRangeFilter(filterName)"
    ></a>
  </button>
</template>

<script setup lang="ts">
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {inject, onMounted} from "vue";
import {storeToRefs} from "pinia";
import {formatPrice} from "@/core/utils";

const filtersStore = useFiltersStore();
const serpStore = useSerpResultsStore()

import {defineProps} from "vue";

const props = defineProps(['activeFilter', 'filterName'])

import {SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!
const {getCurrencyCode} = storeToRefs(serpStore)
onMounted(() => {
    filtersStore.registerAsActiveFilter(props.filterName, props.activeFilter)
})
</script>
